module.exports = __webpack_public_path__ + "img/upload.0ac7dd49.svg";